module.exports = __webpack_public_path__ + "static/key-thekingsbird-82d19aa0364cee2968149fbfe40bdd15.webp";